import ApiClient from './ApiClient';

/**
 * The board definitions the deals sit on: a pipeline is a name plus its stages,
 * which ride along with every read. Nothing is deleted here — archiving a
 * pipeline or a stage is an update that sets `archived_at`.
 */
class PipelinesAPI extends ApiClient {
  constructor() {
    super('pipelines', { accountScoped: true });
  }
}

export default new PipelinesAPI();
